"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const utilitycancelanytimesm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-utilitycancelanytimesm` : '') + (description ? ` desc-utilitycancelanytimesm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-utilitycancelanytimesm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-utilitycancelanytimesm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z",
    fill: "#B30000"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2v20a9.9 9.9 0 0 1-7.07-2.93A10.18 10.18 0 0 1 2.02 12a9.96 9.96 0 0 1 3.06-7.21C7.08 2.89 9.43 1.97 12 2Z",
    fill: "#B30000"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.57 7.63c.5.5.5 1.3 0 1.8L9.4 16.6a1.27 1.27 0 0 1-1.8-1.8l7.18-7.17c.5-.5 1.3-.5 1.79 0Z",
    fill: "#FFE5E5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.6 7.63c-.49.5-.49 1.3 0 1.8l7.18 7.17a1.27 1.27 0 0 0 1.79-1.8L9.4 7.63c-.5-.5-1.3-.5-1.79 0Z",
    fill: "#FFE5E5"
  }));
};
var _default = exports.default = utilitycancelanytimesm;